import { createContext } from "react";

export const CardContext = createContext<{
  expandable: boolean;
  defaultExpanded: boolean;
  expanded?: boolean;
  disabled?: boolean;
  hideExpandIcon?: boolean;
}>({ expandable: false, defaultExpanded: false });
